/** @jsx jsx */
import { jsx } from "frontend/src/utils/jsx"
import { SectionGrid, Grid } from "frontend/src/components/Layout"
import { CMSLink } from "frontend/src/components/CMSLink"

function ImageBenefitsCtaDesktop({ imageURL, buttonText, benefits }) {
  return (
    <Grid columns="2fr 3fr" sx={{ display: ["none", "none", "grid"] }}>
      <div
        sx={{
          width: ["unset", "unset", "33.5825vw", "404px"],
          height: ["64vw", "256px", "21.28vw", "256px"],
          gridColumn: "1 / span 1",
        }}
      >
        <img
          src={imageURL}
          alt="sleep.ink"
          sx={{
            width: "100%",
          }}
        />
      </div>
      <div
        sx={{
          gridColumn: "2 / span 1",
          pt: 3,
        }}
      >
        {benefits.map((benefit, index) => {
          const { text, icon } = benefit
          return (
            <div
              key={index}
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                alignItems: "baseline",
                my: 3,
                width: "100%",
              }}
            >
              <img
                src={icon}
                alt="checkmark"
                sx={{
                  color: "white",
                  mr: 3,
                  width: ["unset", "unset", "1.82875vw", "22px"],
                  height: ["unset", "unset", "1.82875vw", "22px"],
                }}
              />
              <p
                sx={{
                  color: "white",
                  fontFamily: "body",
                  fontWeight: 400,
                  fontSize: ["unset", "unset", "1.317631vw", "15.8512px"],
                  lineHeight: ["unset", "unset", "2.16125vw", "26px"],
                }}
              >
                {text}
              </p>
            </div>
          )
        })}
        <div sx={{ width: "100%" }}>
          <CMSLink
            link={{
              externalUrl: "#angebot",
              follow: false,
              newtab: false,
              event: "anchorClick",
              destination: "offerSection",
              pageType: "LandingPage",
              section: "benefits",
            }}
            sx={{
              backgroundColor: "background",
              color: "almostBlack",
              width: ["unset", "unset", "20.531875vw", "247px"],
              textAlign: "center",
              borderRadius: "41px",
              mt: 5,
              fontFamily: "body",
              fontWeight: 700,
              fontSize: ["unset", "unset", "1.647072vw", "19.8144px"],
              height: ["unset", "unset", "3.15875vw", "38px"],
              lineHeight: ["unset", "unset", "3.15875vw", "38px"],
              display: "inline-block",
            }}
          >
            {buttonText}
          </CMSLink>
        </div>
      </div>
    </Grid>
  )
}

function ImageBenefitsCtaMobile({ imageURL, buttonText, benefits }) {
  return (
    <div sx={{ display: ["block", "block", "none"] }}>
      <div sx={{ height: "100%", maxWidth: "400px", mx: "auto" }}>
        <div
          sx={{
            width: ["85.5vw", "342px", "28.42875vw", "342px"],
            height: ["54vw", "216px", "17.955vw", "216px"],
          }}
        >
          <img
            src={imageURL}
            alt="sleep.ink"
            sx={{
              width: "100%",
              position: "relative",
              bottom: "30px",
            }}
          />
        </div>
        <div
          sx={{
            pt: 6,
            position: "relative",
            bottom: "30px",
          }}
        >
          {benefits.map((benefit, index) => {
            const { text, icon } = benefit
            return (
              <div
                key={index}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  alignItems: "baseline",
                  my: 3,
                  width: ["80%", "80%", "100%"],
                  mx: ["auto", "auto", "unset"],
                }}
              >
                <img
                  src={icon}
                  alt="checkmark"
                  sx={{
                    zIndex: 2,
                    width: ["5.5vw", "22px", "1.82875vw", "22px"],
                    height: ["5.25vw", "21px", "1.745025vw", "21px"],
                    mr: 4,
                  }}
                />
                <p
                  sx={{
                    color: "background",
                    fontFamily: "body",
                    fontWeight: 400,
                    fontSize: ["3.9628vw", "15.8512px", "1.317631vw", "15.8512px"],
                    lineHeight: ["6.5vw", "26px", "2.16125vw", "26px"],
                  }}
                >
                  {text}
                </p>
              </div>
            )
          })}
          <div sx={{ width: "100%", mx: "auto", textAlign: "center" }}>
            <CMSLink
              link={{
                externalUrl: "#angebot",
                follow: false,
                newtab: false,
                event: "anchorClick",
                destination: "offerSection",
                pageType: "LandingPage",
                section: "benefits",
              }}
              sx={{
                backgroundColor: "background",
                color: "almostBlack",
                width: ["61.75vw", "247px", "20.531875vw", "247px"],
                textAlign: "center",
                borderRadius: "41px",
                mt: 5,
                fontFamily: "body",
                fontWeight: 700,
                fontSize: ["4.9536vw", "19.8144px", "1.647072vw", "19.8144px"],
                height: ["9.5vw", "38px", "3.15875vw", "38px"],
                lineHeight: ["9.5vw", "38px", "3.15875vw", "38px"],
                display: "inline-block",
              }}
            >
              {buttonText}
            </CMSLink>
          </div>
        </div>
      </div>
    </div>
  )
}

function ImageBenefitsCta({ imageURL, buttonText, benefits }) {
  return (
    <SectionGrid sx={{ backgroundColor: "almostBlack", py: ["unset", "unset", 4] }}>
      <SectionGrid.narrow>
        <ImageBenefitsCtaDesktop imageURL={imageURL} buttonText={buttonText} benefits={benefits} />
        <ImageBenefitsCtaMobile imageURL={imageURL} buttonText={buttonText} benefits={benefits} />
      </SectionGrid.narrow>
    </SectionGrid>
  )
}

export { ImageBenefitsCta }
